import { Link } from "react-router-dom";
import Table, { ColumnDefinitionType } from '../../../../components/Table'
import { useArea } from "../../../../hooks/useArea";
import { Area } from "../../../../types/Area";
import { Loading } from "../../../../components/Loading";
import { useEffect, useMemo, useState } from "react";
import Confirm from "../../../../components/Confirm";
import { toast } from "react-toastify";


const TableArea = () => {
    const { areaList, loading, areaInitial, eliminarArea, activarArea, buscarAreas, filtro } = useArea();

    const [showModal, setShowModal] = useState<boolean>(false);
    const [accion, setAccion] = useState<'eliminar' | 'reactivar'>('eliminar');
    const [data, setData] = useState<Area>(areaInitial);
    const toggle = () => setShowModal(!showModal);

    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        setPage(1);
    }, [areaList]);

    const confirmar = () => {
        const esEliminar = accion === 'eliminar';
        const request = esEliminar ? eliminarArea(String(data.id)) : activarArea(String(data.id));
        request
            .then(() => {
                toast.success(esEliminar ? 'Se dio de baja el Área correctamente' : 'Se reactivó el Área correctamente');
                return buscarAreas(filtro);
            })
            .catch((err: any) => {
                if (err?.response?.status === 403) {
                    toast.error(esEliminar ? 'No tiene permisos para eliminar el Área' : 'No tiene permisos para reactivar el Área');
                } else {
                    toast.error(err?.response?.data?.message || (esEliminar ? 'Hubo un error al eliminar el Área' : 'Hubo un error al reactivar el Área'));
                }
            })
        toggle();
    }

    const totalPages = Math.max(1, Math.ceil((areaList?.length || 0) / pageSize));
    const dataPaginada = useMemo(() => {
        const start = (page - 1) * pageSize;
        return (areaList || []).slice(start, start + pageSize);
    }, [areaList, page, pageSize]);

    const columns: ColumnDefinitionType<Area, keyof Area>[] = [
        {
            key: 'nombre',
            header: 'Nombre',
        },
        {
            key: 'descripcion',
            header: 'Descripción',
        },
        {
            key: 'activo',
            header: 'Estado',
            cell: (data: Area) => <>{data.activo ? 'ACTIVA' : 'INACTIVA'}</>
        },
        {
            key: 'id',
            header: 'Acciones',
            cell: (data: Area) =>
                <>
                    <Link to={`/areas/editar/${data.id}?action=view`} title="Visualizar">
                        <i className="fa fa-eye text-secondary me-2" aria-hidden="true"></i>
                    </Link>
                    <Link to={`/areas/editar/${data.id}`} title="Editar" >
                        <i className="fa fa-pencil text-custom me-2" aria-hidden="true"></i>
                    </Link>
                    {data.activo &&
                        <Link to="#" title="Eliminar"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setData(data);
                                setAccion('eliminar');
                                setShowModal(true)
                            }}
                        >
                            <i className="fa fa-trash-o text-danger" aria-hidden="true"></i>
                        </Link>
                    }
                    {!data.activo &&
                        <Link to="#" title="Reactivar"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setData(data);
                                setAccion('reactivar');
                                setShowModal(true)
                            }}
                        >
                            <i className="fa fa-undo text-custom" aria-hidden="true"></i>
                        </Link>
                    }
                </>
        },
    ]

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title={accion === 'eliminar' ? 'Eliminar' : 'Reactivar'} yesFn={confirmar}>
                <div className="form-horizontal">
                    <div className="row">
                        <p>{accion === 'eliminar'
                            ? `¿Está seguro que desea dar de baja el Área ${data.nombre}?`
                            : `¿Está seguro que desea reactivar el Área ${data.nombre}?`}</p>
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>

                                        Listado de Áreas
                                        <Link to={`/areas/nuevo`} title="Nuevo" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}>
                                            <i className="fa fa-plus margin-right-10"></i> Nuevo
                                        </Link>

                                    </h4>

                                </div>

                                <div className="table-responsive">
                                    <br />

                                    {loading ? <Loading /> : <Table data={dataPaginada} columns={columns}></Table>}

                                    <div className="row mx-0 mt-2 align-items-center">
                                        <div className="col-auto">
                                            <label className="me-2">Mostrar</label>
                                            <select
                                                className="form-control select-list d-inline-block"
                                                style={{ width: 'auto' }}
                                                value={pageSize}
                                                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <label className="ms-2">registros por página</label>
                                        </div>
                                        <div className="col text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm mx-1"
                                                disabled={page <= 1}
                                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                            >
                                                <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                            </button>
                                            <span>Página {page} de {totalPages}</span>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm mx-1"
                                                disabled={page >= totalPages}
                                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                            >
                                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default TableArea;
